// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1Yj-v","consentsList":"PatientConsents_consentsList___2RVP","consentsListEmpty":"PatientConsents_consentsListEmpty__VXpSL"};